import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-26a2600d"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "cooperative_partner" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, [
  /*#__PURE__*/_createElementVNode("h3", null, "合作伙伴")
], -1))
const _hoisted_3 = { class: "principally icon_box" }
const _hoisted_4 = ["onMouseenter"]
const _hoisted_5 = ["src"]
const _hoisted_6 = { class: "principally icon_box" }
const _hoisted_7 = ["onMouseenter"]
const _hoisted_8 = ["src"]
const _hoisted_9 = { class: "principally icon_box" }
const _hoisted_10 = ["onMouseenter"]
const _hoisted_11 = ["src"]
const _hoisted_12 = { class: "principally icon_box" }
const _hoisted_13 = ["onMouseenter"]
const _hoisted_14 = ["src"]
const _hoisted_15 = { class: "government" }
const _hoisted_16 = { class: "governmentBox" }
const _hoisted_17 = { class: "_img" }
const _hoisted_18 = ["src"]

import { ref } from "vue";
import zky_color from "@/static/Home/partner/color/zky.png";
import zdh_color from "@/static/Home/partner/color/zdh.png";
import sfky_color from "@/static/Home/partner/color/sfky.png";
import gjdw_color from "@/static/Home/partner/color/gjdw.png";
import zgnj_color from "@/static/Home/partner/color/zgnj.png";

import zgdj_color from "@/static/Home/partner/color/zgdj.png";
import zgsy_color from "@/static/Home/partner/color/zgsy.png";
import zglt_color from "@/static/Home/partner/color/zglt.png";
import zgdx_color from "@/static/Home/partner/color/zgdx.png";

import nxd_color from "@/static/Home/partner/color/nxd.png";
import hhdx_color from "@/static/Home/partner/color/hhdx.png";
import zgnydx_color from "@/static/Home/partner/color/zgnydx.png";
import whdx_color from "@/static/Home/partner/color/whdx.png";

import sthjb_color from "@/static/Home/partner/color/sthjb.png";
import zgmh_color from "@/static/Home/partner/color/zgmh.png";
import gjgw_color from "@/static/Home/partner/color/gjgw.png";
import zgsh_color from "@/static/Home/partner/color/zgsh.png";
import bd_color from "@/static/Home/partner/color/bd.png";
import jd_color from "@/static/Home/partner/color/jd.png";
import group_color from "@/static/Home/partner/color/group.png";

import zgyd_color from "@/static/Home/partner/color/zgyd.png";
import zgyc_color from "@/static/Home/partner/color/zgyc.png";
import gddt_color from "@/static/Home/partner/color/gddt.png";
import zghydx_color from "@/static/Home/partner/color/zghydx.png";

import zky from "@/static/Home/partner/gray/zky.png";
import zdh from "@/static/Home/partner/gray/zdh.png";
import sfky from "@/static/Home/partner/gray/sfky.png";
import gjdw from "@/static/Home/partner/gray/gjdw.png";
import zgnj from "@/static/Home/partner/gray/zgnj.png";

import zgdj from "@/static/Home/partner/gray/zgdj.png";
import zgsy from "@/static/Home/partner/gray/zgsy.png";
import zglt from "@/static/Home/partner/gray/zglt.png";
import zgdx from "@/static/Home/partner/gray/zgdx.png";

import nxd from "@/static/Home/partner/gray/nxd.png";
import hhdx from "@/static/Home/partner/gray/hhdx.png";
import zgnydx from "@/static/Home/partner/gray/zgnydx.png";
import whdx from "@/static/Home/partner/gray/whdx.png";

import sthjb from "@/static/Home/partner/gray/sthjb.png";
import zgmh from "@/static/Home/partner/gray/zgmh.png";
import gjgw from "@/static/Home/partner/gray/gjgw.png";
import zgsh from "@/static/Home/partner/gray/zgsh.png";
import bd from "@/static/Home/partner/gray/bd.png";
import jd from "@/static/Home/partner/gray/jd.png";
import group from "@/static/Home/partner/gray/group.png";

import zgqxj from "@/static/Home/partner/zgqxj.png";
import yjzx from "@/static/Home/partner/yjzx.png";
import qxfwxh from "@/static/Home/partner/qxfwxh.png";
import zgqxxh from "@/static/Home/partner/zgqxxh.png";
import ams from "@/static/Home/partner/ams.png";

import zgyd from "@/static/Home/partner/gray/zgyd.png";
import zgyc from "@/static/Home/partner/gray/zgyc.png";
import gddt from "@/static/Home/partner/gray/gddt.png";
import zghydx from "@/static/Home/partner/gray/zghydx.png";


export default /*#__PURE__*/_defineComponent({
  __name: 'cooperativePartner',
  setup(__props) {

const cooperativeList = ref();
const governmentList = ref();
cooperativeList.value = [
  [
    {
      icon_color: zgnj_color,
      icon_gary: zgnj,
    },
    {
      icon_color: zgdj_color,
      icon_gary: zgdj,
    },
    {
      icon_color: gjdw_color,
      icon_gary: gjdw,
    },
    {
      icon_color: zglt_color,
      icon_gary: zglt,
    },
    {
      icon_color: zgdx_color,
      icon_gary: zgdx,
    },
    {
      icon_color: zgyd_color,
      icon_gary: zgyd,
    },
  ],
  [
    { icon_color: sthjb_color, icon_gary: sthjb },
    { icon_color: zgmh_color, icon_gary: zgmh },
    { icon_color: gjgw_color, icon_gary: gjgw },
    { icon_color: zgsy_color, icon_gary: zgsy },
    { icon_color: zgsh_color, icon_gary: zgsh },
    { icon_color: zgyc_color, icon_gary: zgyc },
  ],
  [
    { icon_color: bd_color, icon_gary: bd },
    { icon_color: jd_color, icon_gary: jd },
    { icon_color: sfky_color, icon_gary: sfky },
    { icon_color: zdh_color, icon_gary: zdh },
    { icon_color: group_color, icon_gary: group },
    { icon_color: gddt_color, icon_gary: gddt },
  ],
  [
    { icon_color: zky_color, icon_gary: zky },
    { icon_color: nxd_color, icon_gary: nxd },
    { icon_color: hhdx_color, icon_gary: hhdx },
    { icon_color: zgnydx_color, icon_gary: zgnydx },
    { icon_color: whdx_color, icon_gary: whdx },
    { icon_color: zghydx_color, icon_gary: zghydx },
  ],
];

governmentList.value = [
  { icon: zgqxj, title: "中国气象局\n合作企业" },
  { icon: yjzx, title: "国家预警信息发布中心\n合作企业" },
  { icon: qxfwxh, title: "中国气象服务协会\n会员单位" },
  { icon: zgqxxh, title: "中国气象学会\n会员单位" },
  { icon: ams, title: "中国气象科学\n研究院合作单位" },
];
const getHoverIndex = ref(-1);
const getHoverIndex1 = ref(-1);
const getHoverIndex2 = ref(-1);
const getHoverIndex3 = ref(-1);
const enter = (index: number) => {
  getHoverIndex.value = index;
};
const enter1 = (index: number) => {
  getHoverIndex1.value = index;
};
const enter2 = (index: number) => {
  getHoverIndex2.value = index;
};
const enter3 = (index: number) => {
  getHoverIndex3.value = index;
};
const leave = (index: number) => {
  getHoverIndex.value = index;
  getHoverIndex1.value = index;
  getHoverIndex2.value = index;
  getHoverIndex3.value = index;
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("ul", _hoisted_3, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(cooperativeList.value[0], (item, index) => {
        return (_openBlock(), _createElementBlock("li", {
          class: "icon",
          key: index,
          onMouseenter: ($event: any) => (enter(index)),
          onMouseleave: _cache[0] || (_cache[0] = ($event: any) => (leave(-1)))
        }, [
          _createElementVNode("img", {
            alt: "",
            src: getHoverIndex.value === index ? item.icon_color : item.icon_gary
          }, null, 8, _hoisted_5)
        ], 40, _hoisted_4))
      }), 128))
    ]),
    _createElementVNode("ul", _hoisted_6, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(cooperativeList.value[1], (item, index) => {
        return (_openBlock(), _createElementBlock("li", {
          class: "icon",
          key: index,
          onMouseenter: ($event: any) => (enter1(index)),
          onMouseleave: _cache[1] || (_cache[1] = ($event: any) => (leave(-1)))
        }, [
          _createElementVNode("img", {
            src: getHoverIndex1.value === index ? item.icon_color : item.icon_gary,
            alt: ""
          }, null, 8, _hoisted_8)
        ], 40, _hoisted_7))
      }), 128))
    ]),
    _createElementVNode("ul", _hoisted_9, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(cooperativeList.value[2], (item, index) => {
        return (_openBlock(), _createElementBlock("li", {
          class: "icon",
          key: index,
          onMouseenter: ($event: any) => (enter2(index)),
          onMouseleave: _cache[2] || (_cache[2] = ($event: any) => (leave(-1)))
        }, [
          _createElementVNode("img", {
            src: getHoverIndex2.value === index ? item.icon_color : item.icon_gary,
            alt: ""
          }, null, 8, _hoisted_11)
        ], 40, _hoisted_10))
      }), 128))
    ]),
    _createElementVNode("ul", _hoisted_12, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(cooperativeList.value[3], (item, index) => {
        return (_openBlock(), _createElementBlock("li", {
          class: "icon",
          key: index,
          onMouseenter: ($event: any) => (enter3(index)),
          onMouseleave: _cache[3] || (_cache[3] = ($event: any) => (leave(-1)))
        }, [
          _createElementVNode("img", {
            src: getHoverIndex3.value === index ? item.icon_color : item.icon_gary,
            alt: ""
          }, null, 8, _hoisted_14)
        ], 40, _hoisted_13))
      }), 128))
    ]),
    _createElementVNode("div", _hoisted_15, [
      _createElementVNode("ul", _hoisted_16, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(governmentList.value, (item, index) => {
          return (_openBlock(), _createElementBlock("li", { key: index }, [
            _createElementVNode("div", null, [
              _createElementVNode("div", _hoisted_17, [
                _createElementVNode("img", {
                  src: item.icon,
                  alt: ""
                }, null, 8, _hoisted_18)
              ]),
              _createElementVNode("p", null, _toDisplayString(item.title), 1)
            ])
          ]))
        }), 128))
      ])
    ])
  ]))
}
}

})